interface EnvConfig {
  apiUrl: string;
  wsUrl: string;
  environment: 'development' | 'production' | 'test';
  isDevelopment: boolean;
  isProduction: boolean;
  features: {
    enableDevTools: boolean;
    enableAnalytics: boolean;
  };
}

const getEnv = (key: string, defaultValue?: string): string => {
  const value = import.meta.env[key] as string | undefined;
  if (value === undefined && defaultValue === undefined) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value || defaultValue || '';
};

const getEnvironment = (): EnvConfig['environment'] => {
  const mode = getEnv('MODE', 'development');
  if (mode === 'production' || mode === 'test') {
    return mode;
  }
  return 'development';
};

const getApiUrl = () => {
  const rawUrl = getEnv('VITE_API_URL', 'http://localhost:8080/api');
  try {
    // Use URL constructor to normalize
    const url = new URL(rawUrl);
    // Ensure no trailing slash for consistency
    if (url.pathname.endsWith('/')) {
      url.pathname = url.pathname.slice(0, -1);
    }
    // Ensure it ends with /api if not already present (legacy logic preservation)
    // Note: This assumes the VITE_API_URL might NOT include /api, which is ambiguous.
    // Ideally VITE_API_URL should be the full base URL.
    // But following existing logic:
    if (!url.pathname.endsWith('/api')) {
      url.pathname = `${url.pathname}/api`.replace('//', '/');
    }
    return url.toString();
  } catch {
    // Fallback for relative URLs or invalid URLs
    let url = rawUrl.replace(/\/+$/, '');
    if (!url.endsWith('/api')) {
      url += '/api';
    }
    return url;
  }
};

export const env: EnvConfig = {
  apiUrl: getApiUrl(),
  wsUrl: getEnv('VITE_WS_URL', 'ws://localhost:8080/ws'),
  environment: getEnvironment(),
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  features: {
    enableDevTools: import.meta.env.DEV,
    enableAnalytics: import.meta.env.PROD,
  },
};

export default env;
